import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { TextField as MuiTextField, Grid, withStyles } from '@material-ui/core';
var TextField = withStyles(function (theme) {
  return {
    root: {
      backgroundColor: 'transparent !important',
      flex: 1,
      '& input': {
        backgroundColor: 'transparent !important',
        border: 'none !important',
        padding: '7px 6px 0 6px !important',
        height: '34px',
        '&:before': {
          marginTop: '0'
        }
      },
      '& label': {
        color: "".concat(theme.palette.primary.main, " !important"),
        bottom: '24px !important',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '7px 6px'
      },
      '& label + .MuiInput-formControl': {
        marginTop: '0 !important'
      },
      '& .MuiInput-underline:before': {
        borderColor: "".concat(theme.palette.primary.main, " !important")
      }
    }
  };
})(MuiTextField);

var KailonaTextField = /*#__PURE__*/function (_Component) {
  _inherits(KailonaTextField, _Component);

  var _super = _createSuper(KailonaTextField);

  function KailonaTextField() {
    _classCallCheck(this, KailonaTextField);

    return _super.apply(this, arguments);
  }

  _createClass(KailonaTextField, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, this.props, {
        inputProps: {
          style: {
            fontSize: 12
          }
        },
        InputLabelProps: {
          style: {
            fontSize: 12
          }
        }
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return KailonaTextField;
}(Component);

export { KailonaTextField as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TextField, "TextField", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/TextField/KailonaTextField.js");
  reactHotLoader.register(KailonaTextField, "KailonaTextField", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/TextField/KailonaTextField.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();